module.exports = __webpack_public_path__ + "img/graden2.bbcfdc49.png";